export const INSTANCE_BY_ID_SUCCESS = 'INSTANCE_BY_ID_SUCCESS';
export const INSTANCE_BY_ID_REQUEST = 'INSTANCE_BY_ID_REQUEST';
export const INSTANCE_BY_ID_ERROR = 'INSTANCE_BY_ID_ERROR';
